import React, { memo } from 'react';

import { Box, Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { badgeContainerStyles, badgeLabelStyles } from './NavNeededCountBadge.styles';

/**
 * Count badge for a modal OPENER (DEV-4386): the number of checklist-linked
 * fields inside the modal that still need attention, so a user knows the modal
 * needs work without opening it. Purely presentational — the caller resolves the
 * count from `selectIncompleteLinkedNav` via `getNavNeededState` (the SAME roll-up
 * the field/section/nav indicators use) and passes it in. Renders nothing when
 * the count is zero. Pairs with the roll-up "Needed" pill `NavNeededIndicator`.
 */
const NavNeededCountBadge = ({ count = 0 }) => {
  if (!count) {
    return null;
  }

  const tooltip =
    count === 1 ? '1 field still needs attention' : `${count} fields still need attention`;

  return (
    <Tooltip title={tooltip}>
      <Box aria-label={tooltip} component="span" sx={badgeContainerStyles}>
        <Typography component="span" sx={badgeLabelStyles} variant="bold12">
          {count}
        </Typography>
      </Box>
    </Tooltip>
  );
};

NavNeededCountBadge.propTypes = {
  count: PropTypes.number,
};

export default memo(NavNeededCountBadge);
